import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { ICPapperAct } from '../../assets';
import { Announcement, Button, CardAction, Navbar, Sidebar, Spacer } from '../../components';
import './Dashboard.scss';
import FeaturingApp from './FeaturingApp';
import FeatureApp from '../../data-dummy/dummy_feature_app.json'
function Dashboard() {
  const [closeSide, setCloseSide] = useState(false)
  const [apps, setApps] = useState([])
  const [ann, setAnn] = useState(true)

  useEffect(() => {
    setApps(FeatureApp.feature_app)
  }, [apps])
  const toggleMenu = () => {
    if (closeSide) {
      setCloseSide(false)
    } else {
      setCloseSide(true)
    }
  }

  const classContentWrapper = cx({
    'scrollCustom': true,
    'contentWrapper': true,
    'wide': closeSide
  })


  return (
    <div className="page">
      <Navbar onClick={toggleMenu} closeSide={closeSide} />
      <div className="mainWrapper">
        <Sidebar closeSide={closeSide} />
        <div className={classContentWrapper}>
          <div className="container-fluid">
            <Spacer h={20} />
            {
              ann &&
              <Announcement
                message="We have not released the token yet, but consider airdrop for those who test the mobile version apps"
                varian="dark"
                onClick={() => setAnn(false)}
              />
            }
            <CardAction />
            <Spacer h={20} />
            <div className="cardContainer">
              <div className="row align-items-center">
                <div className="col-lg-8">
                  <span className="titleCard">Short Brief</span>
                  <Spacer h={20} />
                  <span className="d-block mb-3">Have you ever getting rugged for buying tokens or NFTs?</span>
                  <span className="d-block">
                    <b> Defi Candy </b>
                    apps help you doing smart contract analysis before making investment decision. It supports smart contract for standard token and NFT that lives in Ethereum, Binance and Polygon Network.
                  </span>
                  <span className="d-block my-3">
                    Please have a good time play around with the apps.
                  </span>
                  <span>
                    Read the whitepaper or jump into our official telegram community for more information.
                  </span>
                </div>
                <div className="col-lg-12 my-3">
                  <a href="./media/MOONPAPER.pdf" className="myBtn orange light" download>
                    <img src={ICPapperAct} alt="" />
                    <Spacer w={10} />
                    Download Moonpaper
                  </a>
                </div>
              </div>
            </div>
            <div className="cardContainer d-none">
              <span className="titleCard">Featuring Apps</span>
              <Spacer h={20} />
              <div className="row">
                {
                  apps &&
                  apps.map((app, key) => {
                    return <FeaturingApp desc={app.desc} image={`dummy_image/${app.image}`} title={app.title} key={key} />
                  })
                }
                <Button label="Download And More in Development" varian="orange light mx-auto" width={320} />
              </div>
            </div>
            <Spacer h={30} />
          </div>
        </div>
      </div>
    </div>
  )
}
export default Dashboard
